import { useState } from "react";
import SectionHeading from "../components/SectionHeading";
import { WEB3FORMS_ACCESS_KEY } from "../data/siteData";
import "./Admission.css";

const STEPS = [
  "Complete and submit the Enquiry form with your details.",
  "We will assist you in scheduling a visit to Agape Garden Play School.",
  "Explore our campus and connect with our Educators.",
  "Enroll your child and become a part of our Nurturing community.",
];

const EMPTY_FORM = { name: "", email: "", phone: "", pin: "" };

export default function Admission() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [status, setStatus] = useState({ type: "idle", message: "" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "sending", message: "Sending…" });

    const body = new FormData();
    body.append("access_key", WEB3FORMS_ACCESS_KEY);
    Object.entries(form).forEach(([key, value]) => body.append(key, value));

    try {
      const response = await fetch("https://api.web3forms.com/submit", { method: "POST", body });
      const data = await response.json();

      if (data.success) {
        setStatus({ type: "success", message: "Enquiry sent successfully! We'll be in touch soon." });
        setForm(EMPTY_FORM);
      } else {
        setStatus({ type: "error", message: "Failed to send enquiry. Please try again." });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Something went wrong while sending your enquiry." });
    }
  };

  return (
    <section id="admission" className="section">
      <div className="container">
        <SectionHeading plain="Admission" accent="Enquiry" />

        <div className="admission__grid">
          <ol className="admission__steps">
            {STEPS.map((step) => (
              <li key={step}>
                <img src="/images/arrow.png" alt="" />
                <p>{step}</p>
              </li>
            ))}
          </ol>

          <form className="admission__form" onSubmit={handleSubmit}>
            <h3>Enquire Now</h3>

            <label className="sr-only" htmlFor="enquiry-name">Name</label>
            <input id="enquiry-name" name="name" type="text" placeholder="Name" autoComplete="name" required value={form.name} onChange={handleChange} />

            <label className="sr-only" htmlFor="enquiry-email">Email</label>
            <input id="enquiry-email" name="email" type="email" placeholder="Email" autoComplete="email" required value={form.email} onChange={handleChange} />

            <label className="sr-only" htmlFor="enquiry-phone">Phone number</label>
            <input id="enquiry-phone" name="phone" type="tel" placeholder="Phone Number" autoComplete="tel" required value={form.phone} onChange={handleChange} />

            <label className="sr-only" htmlFor="enquiry-pin">Pin code</label>
            <input id="enquiry-pin" name="pin" type="text" inputMode="numeric" placeholder="Pin Code" autoComplete="postal-code" required value={form.pin} onChange={handleChange} />

            <button type="submit" className="btn" disabled={status.type === "sending"}>
              {status.type === "sending" ? "Sending…" : "Submit"}
            </button>

            {status.message && status.type !== "sending" && (
              <p className={`admission__status admission__status--${status.type}`} role="status">
                {status.message}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
